import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import { useAppContext } from '../../../../Context/App/Provider';

import './historyDetails.css';

import { getTimeAsZDateTime } from '../../../../Functions/utils';

import Typography from "@material-ui/core/Typography";

const tab = "       ";

export default function Deployment({ selected, deployment, expanded, setExpanded, extraDiskHealth, extraDiskPerf }) {

  // const history = useHistory();
  const [{ settings }] = useAppContext();
  const { t } = useTranslation();

  const open = expanded.includes(deployment.deployment_id);
  const toggleScenario = (deployment) => (
    setExpanded(open ? expanded.filter(s => s != deployment.deployment_id) : [...expanded, deployment.deployment_id])
  );

  const dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  };

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  let selectedTxt = "";
  if (deployment.deployment_id == selected)
    selectedTxt = "_selected";

  return (
    <div className={'container ' + (open ? 'open' + selectedTxt : 'closed' + selectedTxt)}>
      <div className="container__header">
        <div className="container__title" onClick={() => toggleScenario(deployment)}>
          <span className="material-icons">arrow_{open ? 'drop_down' : 'right'}</span>
          <h3>{
            new Date(getTimeAsZDateTime(deployment.date)).toLocaleDateString(settings.lang ? settings.lang : 'en', dateOptions) +
            '   (' + t('reporting.columns.general.id') + ' ' + deployment.deployment_id + /*' - ' + deployment.modules.length + ' module(s) */ ')'
          }
          </h3>
        </div>
      </div>

      <div className="container__content">
        <Table className="container__table">
          {/* <TableHead>
            <TableRow>
              <TableCell><span className="container__table__title">{t('container.modules.title', { s: 's' })}</span></TableCell>
              <TableCell><span className="container__table__title">{t('container.conditions.title')}</span></TableCell>
            </TableRow>
          </TableHead> */}

          <TableBody>

            {deployment && deployment.moduleBootImg && deployment.moduleBootImg.launcher_ver ? (
              <TableRow key={module.id}>
                <TableCell style={{ flexDirection: "column", display: 'inline-block' }}>
                  <Typography className="top">
                    {new Date(getTimeAsZDateTime(deployment.date)).toLocaleDateString(settings.lang ? settings.lang : 'en', options)}
                  </Typography>
                </TableCell>

                  <TableCell style={{ flexDirection: "column" }}>
                    <span>
                    <Typography style={{ color: "black", fontSize: '150%', textDecoration: "underline", display: 'inline-block' }}>
                      {'Boot process (DeployJukebox : '}{deployment.versionDeployJukebox}{' / DeployLauncher : '}{deployment.moduleBootImg.launcher_ver}{')'}
                      </Typography>
                    </span>

                    <span>
                    <Typography style={{ display: 'inline-block' }}>
                      {tab}{'Boot image: '}{deployment.moduleBootImg.current_name}
                      </Typography>
                    </span>
                    <span>
                      <Typography style={{ display: 'inline-block' }}>
                      {tab}{tab}{'(originally: '}{deployment.moduleBootImg.original_name}{') built on '}{deployment.moduleBootImg.date}
                      </Typography>
                    </span>

                    <span>
                      <Typography style={{ display: 'inline-block' }}>
                      {tab}{'WinPE version: '}{deployment.moduleBootImg.winpe_ver}
                      </Typography>
                    </span>

                    <span>
                      <Typography style={{ display: 'inline-block' }}>
                      {tab}{'Boot type: '}{deployment.moduleBootImg.boot_type}
                      </Typography>

                      {
                        deployment.moduleBootImg.secure_boot === '1' ? (
                          <Typography style={{ display: 'inline-block' }}>
                          {' (secure boot)'}
                          </Typography>
                        ) : (<></>)
                      }
                      {
                        deployment.moduleBootImg.t2_security === '1' ? (
                          <Typography style={{ display: 'inline-block' }}>
                          {' (T2 full security)'}
                          </Typography>
                        ) : (<></>)
                      }
                    </span>

                    <span>
                      <Typography style={{ display: 'inline-block' }}>
                      {tab}{'Secure boot: '}{(deployment.moduleBootImg.secure_boot === '1' ? "Yes" : "No")}
                      </Typography>
                    </span>

                  {
                    deployment.lock_bios_admin_password != null ? (
                      <span>
                        <Typography style={{ display: 'inline-block' }}>
                          {tab}{'BIOS admin password lock: '}{(
                            deployment.lock_bios_admin_password === '0' ? "Not usable" : (
                              deployment.lock_bios_admin_password === '1' ? "Password required" : (
                                deployment.lock_bios_admin_password === '2' ? "No password" : "Unknown"
                              )
                            )
                          )}
                        </Typography>
                      </span>
                    ) : (<></>)
                  }

                  {
                    deployment.lock_bios_computrace_status != null ? (
                      <span>
                        <Typography style={{ display: 'inline-block' }}>
                          {tab}{'Absolute status: '}{(
                            deployment.lock_bios_computrace_status === '0' ? "Disabled" : (
                              deployment.lock_bios_computrace_status === '1' ? "Activated" : (
                                deployment.lock_bios_computrace_status === '2' ? "Not detected" : "Unknown"
                              )
                            )
                          )}
                        </Typography>
                      </span>
                    ) : (<></>)
                  }

                  {/* <span>
                    <Typography style={{ display: 'inline-block' }}>
                      {' '}
                    </Typography>
                  </span> */}
                  </TableCell>
              </TableRow>
            ) : (
              <></>
            )}

            {deployment && deployment.modules && deployment.modules.map(module => {

              if (!module.visible) {
                return <div></div>
              }

              const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
              };

              let startDate = " ";
              let endDate = " ";

              if (module.start_date !== null) {
                startDate = new Date(getTimeAsZDateTime(module.start_date)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
              }

              if (module.end_date !== null) {
                endDate = new Date(getTimeAsZDateTime(module.end_date)).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
              }

              return (
                <TableRow key={module.module_id}>
                  <TableCell
                    style={{ flexDirection: "column", justifyContent: "space-between" }}                    
                  >
                    <Typography className="top">{startDate}</Typography>                    
                    <Typography className="bottom">{endDate}</Typography>
                  </TableCell>

                  <TableCell style={{ flexDirection: "column" }}>
                    <div>
                      {module.data && module.data.map(lines => {
                        return (
                          <div>
                            {lines.data && lines.data.map(element => {
                              return (
                                <span>
                                  <Typography style={{ ...element.style, display: 'inline-block' }}>
                                    {element.text}
                                  </Typography>
                                </span>
                              );
                            })}
                          </div>
                        )
                      })}
                    </div>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
